import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedDate, intlShape } from 'react-intl'
import { Link } from 'react-router'
import * as shapes from '../../constant/shapes'
import MiniPlayer from '../../components/miniPlayer/MiniPlayer'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'

import hiResLogo from '../../resources/img/logo-hires-30x30.png'

class AlbumCard extends PureComponent {

	render() {
		const { forceCardHeight, forceImageHeight, album, current, playing } = this.props
		const { id, title, released_at, image, artist, hires } = album
		const { intl } = this.context

		return (
			<article
				className={`item ${current ? (playing ? 'isPlaying' : 'isPause' ) : ''}`}
				style={forceCardHeight ? { height: forceCardHeight } : {}}
			>
				<img
					src={image}
					height={190}
					width={190}
					className="item-cover" style={forceImageHeight ? { height: forceImageHeight } : {}}
					alt={title}
				/>
				<span className="item-overlay" />
				<div className="item-action">
					<span className="item-labelize">
						<FormattedDate
							value={new Date(released_at * 1000)}
							day="numeric"
							month="short"
							year="numeric"
						/>
					</span>
					<Link className="item-cover-link" to={`/album/${id}`} />
					<MiniPlayer
						element={album}
						buttonClassName="bt1 white"
						type={ORIGIN_PLAYQUEUE_TYPES.album}
						sampleable={album.sampleable}
					/>
				</div>
				<div className="item-meta">
					<h3 className="item-name text-overflow" title={title}>
						<Link to={`/album/${id}`}>{title}</Link>
					</h3>
					<p className="c3 text-overflow" title={artist.name}>
						<Link className="item-cover-link" to={`/artist/${artist.id}`}>{artist.name}</Link>
					</p>
					{hires && <img src={hiResLogo} className="item-hires" alt={intl.formatMessage({ id: 'infos.hires' })} height="40" width="40" />}
				</div>
			</article>
		)
	}

}

AlbumCard.propTypes = {
	forceCardHeight: PropTypes.number,
	forceImageHeight: PropTypes.number,
	current: PropTypes.bool,
	playing: PropTypes.bool,
	album: shapes.albumCard
}

AlbumCard.contextTypes = {
	intl: intlShape
}

export default AlbumCard



// WEBPACK FOOTER //
// ./src/pages/artist/AlbumCard.jsx